import * as React from 'react';
import { useState, useEffect } from "react";
import axios from 'axios';
import Sidebar from '../components/sidebar'
import Footer from '../components/footer'
import Head from '../components/head'

export default function Main() {
  const [packages, setpackages] = useState([])
  const [allmonth, setallmonth] = useState([])
  const [month_id, setmonth_id] = useState('')

  useEffect(() => {
    getAllMonth();
  }, []);

  const getAllMonth = async () => {
    const data = new FormData();
    data.append('name', "nme");

    axios({
      method: 'post',
      url: '/api/package/all_month_type.php',
      data: data,
      headers: { 'Content-Type': 'multipart/form-data' },
    })
      .then(s => {

        setallmonth(s.data)
        
        console.log(s.data)
      })
      .catch(s => {
        console.log('here catch =>>', s);
      });
  };

  const getselected_pacakge = async (v) => {
    const data = new FormData();
    data.append('slug', v);

    axios({
      method: 'post',
      url: '/api/package/allpackages_view.php',
      data: data,
      headers: { 'Content-Type': 'multipart/form-data' },
    })
      .then(s => {
        setpackages(s.data)
        console.log(s.data)
      })
      .catch(s => {
        console.log('here catch =>>', s);
      });
  };

  return (
    <>
      <div className="main-wrapper">
        <Sidebar />
        <div className="page-wrapper">
          <Head />
          <div>
            <div className="page-content">
              {/* Modern Header */}
              <div className="row mb-4">
                <div className="col-md-12 grid-margin stretch-card">
                  <div className="card modern-card">
                    <div className="card-header bg-gradient-primary text-white py-4">
                      <div className="d-flex align-items-center">
                        <div className="avatar avatar-sm me-3 bg-white text-dark rounded-circle d-flex align-items-center justify-content-center">
                          <i className="link-icon" data-feather="list" style={{ width: '18px', height: '18px' }}></i>
                        </div>
                        <div>
                          <h4 className="mb-1">View Packages</h4>
                          <span className="opacity-75">Browse and manage all Hajj/Umrah packages</span>
                        </div>
                        <span className="badge bg-light text-dark ms-auto py-2 px-3">
                          <i className="link-icon me-1" data-feather="database" style={{ width: '14px', height: '14px' }}></i>
                          {packages.length} Packages
                        </span>
                      </div>
                    </div>
                    <div className="card-body">
                      {/* Month Filter Section */}
                     <div className="row mb-4">
  <div className="col-12">
    <div className="d-flex justify-content-center">
      <div className="d-flex flex-column flex-md-row align-items-center gap-3" style={{ maxWidth: '500px', width: '100%' }}>
        <div className="w-100" style={{ maxWidth: '300px' }}>
          <label className="form-label fw-bold d-block text-center mb-2">
            <i className="fas fa-filter me-2"></i>
            Select Month / Type
          </label>
          <select
            value={month_id}
            onChange={(v) => { setmonth_id(v.target.value); }}
            className='form-control'
          >
            <option value="">Select Month</option>
            {
              allmonth.map((v) => (
                <option key={v.slug} value={v.slug}>{v.name}</option>
              ))
            }
          </select>
        </div>
        <div className="mt-3 mt-md-0 align-self-end">
          <button
            className="btn btn-primary d-flex align-items-center"
            onClick={() => {
              getselected_pacakge(month_id);
            }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="me-2">
              <circle cx="11" cy="11" r="8"></circle>
              <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
            </svg>
            Get Packages
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

                     {/* Packages List */}
{packages.length > 0 && (
  <div className="mt-4">
    {packages.map((v, i) => (
      <div key={v.id} className="mb-4">
        <div className="card modern-card">
          <div className="card-header" style={{ backgroundColor: '#eaf5f5ff', color: '#059e98' }}>
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h5 className="mb-0" style={{ color: '#059e98' }}>{v.name}</h5>
                <small style={{ opacity: 0.8 }}>ID: {v.id} • Type: {v.package_type_name}</small>
              </div>
              <div className="d-flex align-items-center gap-2">
                <span className="badge" style={{ backgroundColor: 'rgba(234, 215, 215, 0.2)', color: 'black' }}>{v.month_name}</span>
                <span className="badge" style={{ backgroundColor: 'rgba(217, 205, 205, 0.3)', color: 'black' }}>#{i + 1}</span>
                <a href={"updatepackage?id=" + v.id + "&m=" + v.month_id}>
                  <button className="btn btn-sm d-flex align-items-center" style={{ backgroundColor: '#059e98', color: 'white', border: 'none' }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="me-1">
                      <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>
                    </svg>
                    Edit
                  </button>
                </a>
              </div>
            </div>
          </div>
          <div className="card-body">
            {/* Services Summary - Compact Version */}
            <div className="row mb-3">
              <div className="col-12">
                <h6 className="fw-bold mb-2">
                  <i className="fas fa-concierge-bell me-1" style={{ color: '#059e98', fontSize: '0.9rem' }}></i>
                  Services
                </h6>
                <div className="d-flex flex-wrap gap-2">
                  <div className="d-flex align-items-center px-2 py-1 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                    <i className="fas fa-plane me-1" style={{ color: '#059e98', fontSize: '0.8rem' }}></i>
                    <span className="me-1" style={{ fontSize: '0.85rem' }}>Flight:</span>
                    <span className={v.flight === "1" ? "text-success" : "text-danger"} style={{ fontSize: '0.85rem' }}>
                      {v.flight === "1" ? "✓" : "✗"}
                    </span>
                  </div>
                  <div className="d-flex align-items-center px-2 py-1 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                    <i className="fas fa-passport me-1" style={{ color: '#059e98', fontSize: '0.8rem' }}></i>
                    <span className="me-1" style={{ fontSize: '0.85rem' }}>Visa:</span>
                    <span className={v.visa === "1" ? "text-success" : "text-danger"} style={{ fontSize: '0.85rem' }}>
                      {v.visa === "1" ? "✓" : "✗"}
                    </span>
                  </div>
                  <div className="d-flex align-items-center px-2 py-1 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                    <i className="fas fa-bus me-1" style={{ color: '#059e98', fontSize: '0.8rem' }}></i>
                    <span className="me-1" style={{ fontSize: '0.85rem' }}>Transport:</span>
                    <span className={v.transport === "1" ? "text-success" : "text-danger"} style={{ fontSize: '0.85rem' }}>
                      {v.transport === "1" ? "✓" : "✗"}
                    </span>
                  </div>
                  <div className="d-flex align-items-center px-2 py-1 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                    <i className="fas fa-star text-warning me-1" style={{ fontSize: '0.8rem' }}></i>
                    <span className="me-1" style={{ fontSize: '0.85rem' }}>Review:</span>
                    <span style={{ fontSize: '0.85rem' }}>{v.review}</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Description - Compact Version */}
            <div className="row mb-3">
              <div className="col-12">
                <h6 className="fw-bold mb-2">
                  <i className="fas fa-align-left me-1" style={{ color: '#059e98', fontSize: '0.9rem' }}></i>
                  Description
                </h6>
                <p className="text-muted mb-0" style={{ fontSize: '0.9rem', lineHeight: '1.4' }}>
                  {v.des.length > 150 ? `${v.des.substring(0, 150)}...` : v.des}
                </p>
              </div>
            </div>

            {/* Image Details - Compact Version */}
         <div className="row mb-3">
  <div className="col-12">
    <h6 className="fw-bold mb-2">
      <i className="fas fa-image me-1" style={{ color: '#059e98', fontSize: '0.9rem' }}></i>
      Image Details
    </h6>
    <div className="row g-2">
      <div className="col-md-4">
        <div className="p-2 border rounded" style={{ borderColor: '#e0e0e0' }}>
          <small className="text-muted d-block mb-1" style={{ fontSize: '0.8rem' }}>Image URL</small>
          <div className="text-truncate" style={{ fontSize: '0.85rem' }} title={v.img}>
            {v.img}
          </div>
        </div>
      </div>
      <div className="col-md-4">
        <div className="p-2 border rounded" style={{ borderColor: '#e0e0e0' }}>
          <small className="text-muted d-block mb-1" style={{ fontSize: '0.8rem' }}>Alt Text</small>
          <div style={{ fontSize: '0.85rem' }}>{v.alt || '-'}</div>
        </div>
      </div>
      <div className="col-md-4">
        <div className="p-2 border rounded" style={{ borderColor: '#e0e0e0' }}>
          <small className="text-muted d-block mb-1" style={{ fontSize: '0.8rem' }}>Image Title</small>
          <div style={{ fontSize: '0.85rem' }}>{v.img_des || '-'}</div>
        </div>
      </div>
    </div>
  </div>
</div>

            {/* Nights Information - Compact Version */}
            <div className="row mb-3">
              <div className="col-12">
                <h6 className="fw-bold mb-2">
                  <i className="fas fa-moon me-1" style={{ color: '#059e98', fontSize: '0.9rem' }}></i>
                  Nights Breakdown
                </h6>
                <div className="row g-2">
                  <div className="col-3">
                    <div className="card p-2 text-center" style={{ backgroundColor: '#f8f9fa', borderColor: '#059e98' }}>
                      <div className="fw-bold mb-1" style={{ color: '#059e98', fontSize: '1rem' }}>{v.makkah_nights}</div>
                      <small className="text-muted" style={{ fontSize: '0.75rem' }}>Makkah</small>
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="card p-2 text-center" style={{ backgroundColor: '#f8f9fa', borderColor: '#059e98' }}>
                      <div className="fw-bold mb-1" style={{ color: '#059e98', fontSize: '1rem' }}>{v.madinah_nights}</div>
                      <small className="text-muted" style={{ fontSize: '0.75rem' }}>Madinah</small>
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="card p-2 text-center" style={{ backgroundColor: '#f8f9fa', borderColor: '#059e98' }}>
                      <div className="fw-bold mb-1" style={{ color: '#059e98', fontSize: '1rem' }}>{v.extra_nights}</div>
                      <small className="text-muted" style={{ fontSize: '0.75rem' }}>Extra</small>
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="card p-2 text-center text-white" style={{ backgroundColor: '#059e98' }}>
                      <div className="fw-bold mb-1" style={{ fontSize: '1rem' }}>{v.total_nights}</div>
                      <small style={{ fontSize: '0.75rem' }}>Total</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Hotels Information - Compact Version */}
            <div className="row">
              <div className="col-12">
                <h6 className="fw-bold mb-2">
                  <i className="fas fa-hotel me-1" style={{ color: '#059e98', fontSize: '0.9rem' }}></i>
                  Hotels
                </h6>
                <div className="row g-2">
                  <div className="col-4">
                    <div className="card p-2" style={{ borderColor: '#059e98', borderWidth: '1px' }}>
                      <small className="fw-bold d-block mb-1" style={{ color: '#059e98', fontSize: '0.8rem' }}>Makkah</small>
                      <div className="text-truncate" style={{ fontSize: '0.85rem' }} title={v.hotel_makkah_name}>
                        {v.hotel_makkah_name}
                      </div>
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="card p-2" style={{ borderColor: '#059e98', borderWidth: '1px' }}>
                      <small className="fw-bold d-block mb-1" style={{ color: '#059e98', fontSize: '0.8rem' }}>Madinah</small>
                      <div className="text-truncate" style={{ fontSize: '0.85rem' }} title={v.hotel_madinah_name}>
                        {v.hotel_madinah_name}
                      </div>
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="card p-2" style={{ borderColor: '#059e98', borderWidth: '1px' }}>
                      <small className="fw-bold d-block mb-1" style={{ color: '#059e98', fontSize: '0.8rem' }}>Extra</small>
                      <div className="text-truncate mb-1" style={{ fontSize: '0.85rem' }} title={v.hotel_extra_name}>
                        {v.hotel_extra_name || 'N/A'}
                      </div>
                      {v.extra_country && (
                        <small className="text-muted d-block" style={{ fontSize: '0.75rem' }}>
                          <i className="fas fa-flag me-1"></i>
                          {v.extra_country}
                        </small>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    ))}
  </div>
)}

                      {/* No Packages Message */}
                      {packages.length === 0 && month_id && (
                        <div className="text-center py-5">
                          <i className="fas fa-box-open fa-3x text-muted mb-3"></i>
                          <h5 className="text-muted">No packages found for the selected month</h5>
                          <p>Select a different month or create new packages.</p>
                        </div>
                      )}

                      {/* Initial State */}
                      {!month_id && packages.length === 0 && (
                        <div className="text-center py-5">
                          <i className="fas fa-calendar-alt fa-3x text-muted mb-3"></i>
                          <h5 className="text-muted">Select a month to view packages</h5>
                          <p>Choose a month from the dropdown above to display packages.</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </>
  )
}